import React from "react";

const OrderRequestStateContext = React.createContext(null);

export default OrderRequestStateContext;
